import HTTPError from "../error.js";
import { encodeAuthorizationHeader } from "../auth.js";
import { fetchWithTimeout, getPaymentRequestFromHeaders } from "../helpers/index.js";
/** Downloads a blob from a server and returns the Response */
export async function downloadBlob(server, hash, opts) {
    const url = new URL("/" + hash, server);
    const headers = {};
    // attach the auth if its already set
    if (opts?.auth)
        headers["Authorization"] = encodeAuthorizationHeader(opts.auth);
    let download = await fetchWithTimeout(url, {
        headers,
        signal: opts?.signal,
        timeout: opts?.timeout,
    });
    // handle auth and payment
    switch (download.status) {
        case 401: {
            const auth = opts?.auth || (await opts?.onAuth?.(server, hash));
            if (!auth)
                throw new Error("Missing auth handler");
            // Try download with auth
            download = await fetchWithTimeout(url, {
                headers: { ...headers, Authorization: encodeAuthorizationHeader(auth) },
                signal: opts?.signal,
                timeout: opts?.timeout,
            });
            break;
        }
        case 402: {
            if (!opts?.onPayment)
                throw new Error("Missing payment handler");
            const { getEncodedToken } = await import("@cashu/cashu-ts");
            const request = getPaymentRequestFromHeaders(download.headers);
            const token = await opts.onPayment(server, hash, request);
            const payment = getEncodedToken(token);
            // Try download with payment
            download = await fetchWithTimeout(url, {
                headers: { ...headers, "X-Cashu": payment },
                signal: opts?.signal,
                timeout: opts?.timeout,
            });
            break;
        }
    }
    // check download errors
    await HTTPError.handleErrorResponse(download);
    // return the raw response
    return download;
}
